import { render, staticRenderFns } from "./PercentTag.vue?vue&type=template&id=1b94ccbb&scoped=true"
import script from "./PercentTag.vue?vue&type=script&lang=js"
export * from "./PercentTag.vue?vue&type=script&lang=js"
import style0 from "./PercentTag.vue?vue&type=style&index=0&id=1b94ccbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b94ccbb",
  null
  
)

export default component.exports